import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

function getCategoryLabel(slug: string): string {
  const cat = categories.find((c) => c.slug === slug);
  return cat ? cat.name : slug;
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const resolved = items.map((item) => ({
    ...item,
    label: item.label.startsWith('category:')
      ? getCategoryLabel(item.label.replace('category:', ''))
      : item.label,
  }));

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {resolved.map((item, i) => {
          const isLast = i === resolved.length - 1;
          return (
            <li key={i} className="flex items-center gap-1">
              {i > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
              )}
              {item.href && !isLast ? (
                <Link
                  to={item.href}
                  className="text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? 'text-foreground-800 font-medium' : 'text-foreground-500'}>
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}